import loadable from '@loadable/component';

export const UserDashboardAccountSettingsPageLoadable = loadable(
  () => import('./UserDashboardAccountSettingsPage'),
  { resolveComponent: (module) => module.UserDashboardAccountSettingsPage },
);
